import React, { useState } from "react";
import { Button,  TouchableOpacity,  View } from "react-native";
import { StatusBar } from "expo-status-bar";
import { useSelector, useDispatch } from 'react-redux';
import { actions } from "../../store/Reducers/auth";
import Input from "../../components/Forms/Input";
import { useForm } from "react-hook-form";
import api from "../../utils/api";
import tw from "../../styles/tailwind";
import Constants from 'expo-constants'
import { SafeAreaView } from "react-native-safe-area-context";
import { Image } from "expo-image";
import Text from "../../components/Text";
import IconButton from "../../components/IconButton";
import DDCircle from "../../assets/images/svgs/dd_circle"
import PasswordInput from "../../components/Forms/PasswordInput";
import { Illustration } from '../../components/Illustration';

export interface IAppProps { }





export default function LoginScreen(props: IAppProps) {
  const [loginMethod, setLoginMethod] = useState("password");


  

  return (

    <SafeAreaView style={tw`bg-secondary flex-1 items-center justify-between py-10`}>
      <View style={tw`absolute -bottom-50 h-100% left-0 right-0`}>
        {/* <DDCircle fill="#410b61" /> */}
        <DDCircle fill="#733D91" />
      </View>

      <Text style={tw`text-white text-lg`}>Iniciar sesión</Text>

      <Illustration name="logo" width={160} height={96} />

      {
        loginMethod === "password" &&
          <LoginForm
            onForgotPasswordPressed={() => {
              setLoginMethod("magic_link")
            }}
          />
      }

      {
        loginMethod === "magic_link" &&
          <MagicLinkForm
            onBackPressed={() => {
              setLoginMethod("password")
            }}
          />
      }



      <Text style={tw`text-gray-200/40 text-center mt-10`}>v{Constants.expoConfig?.version}</Text>

    </SafeAreaView>
  );
}


function MagicLinkForm({ onBackPressed }){
  const { control, handleSubmit } = useForm();

  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const [responseData, setResponseData] = useState();
  const [magicLinkSent, setMagicLinkSent] = useState();


  function submitForm(data) {
    setSubmitting(true)
    setErrorMessage(null)

    api.post(`/auth/magic-link/send`, data)
      .then(({ data }) => {
        setSubmitting(false)
        setResponseData(data)
        setMagicLinkSent(true)
      })
      .catch(({ response }) => {
        setSubmitting(false)
        setErrorMessage(response?.data?.message)

        if (typeof response?.data == 'string') {
          setErrorMessage(response.data)
        }
      })
  }


  return (
    <View style={tw`w-80%`}>
      <>{magicLinkSent && <Text style={tw`text-white text-center mb-4`}>¡Enlace enviado! Revisa tu correo electrónico o WhatsApp.</Text>}</>

      {
        !magicLinkSent &&
          <>
            <Text style={tw`text-white text-center mb-4`}>Ingresa el <Text style={tw`font-bold`}>correo electrónico</Text> o <Text style={tw`font-bold`}>número de Whatsapp</Text> que usaste al registrarte.</Text>
            <Text style={tw`text-white text-center mb-8`}>Te enviaremos un enlace para que puedas acceder nuevamente a tu cuenta.</Text>

            <Input
              name='username'
              control={control}
              placeholder="Correo Electrónico o Whatsapp"
              autoCapitalize={"none"}
              keyboardType="email-address"
              style={{ container: tw`mb-8`, subcontainer: tw`bg-white`, input: tw`h-12` }}
            />

            <IconButton
              title={submitting ? "Enviando enlace..." : "Enviar enlace"}
              color='primary'
              style={tw`self-center`}
              onPress={handleSubmit(submitForm)}
              disabled={submitting}
            />

            {
              errorMessage &&
              <Text style={tw`text-red-400 font-bold text-center mb-2 mt-8`}>{errorMessage}</Text>
            }
          </>
      }
      

      <TouchableOpacity style={tw`flex self-center py-4 px-6 mt-12 items-center`} onPress={onBackPressed}>
        <Text style={tw`text-white`}>Iniciar sesión con contraseña</Text>
      </TouchableOpacity>
    </View>
  )
}


function LoginForm({ onForgotPasswordPressed }){
  const dispatch = useDispatch()
  const [submitting, setSubmitting] = useState(false);
  const [errorMessage, setErrorMessage] = useState();

  const { control, handleSubmit, formState, formState: { errors }, setError, setValue, watch } = useForm();

  function submitForm(data) {
    console.log(data);

    setSubmitting(true)
    setErrorMessage(null)

    api.post(`/auth/login`, data)
      .then(({ data }) => {
        dispatch(actions.login({}, data.token))
      })
      .catch(({ response }) => {
        setSubmitting(false)
        setErrorMessage(response?.data?.message)

        if (typeof response?.data == 'string') {
          setErrorMessage(response.data)
        }
      })
    // dispatch(actions.login({id: 123, name: "paco"}, "new token"))
  }

  return (
    <View style={tw``}>
      <View style={tw``}>
        <Text style={tw`text-white`}>Correo electrónico</Text>

        <Input
          name='username'
          control={control}
          // placeholder="Correo Electrónico"
          rules={{ required: true }}
          autoCapitalize={"none"}
          keyboardType="email-address"
          enterKeyHint={"next"}
          style={{ container: tw`w-80`, subcontainer: tw`bg-white`, input: tw`h-12` }}
        />
      </View>

      <View style={tw``}>
        <Text style={tw`text-white`}>Contraseña</Text>

        <PasswordInput name={'password'} control={control} rules={{ required: true }} />
      </View>

      {
        errorMessage &&
        <Text style={tw`text-red-400 text-center mb-2 mt-2`}>{errorMessage}</Text>
      }

      <IconButton
        title={submitting ? "Iniciando sesión..." : "Iniciar sesión"}
        disabled={submitting}
        onPress={handleSubmit(submitForm)}
        color={'primary'}
        style={tw`self-center mt-5`}
      />

      <TouchableOpacity style={tw`flex self-center py-4 px-6 mt-6 items-center`} onPress={onForgotPasswordPressed}>
        <Text style={tw`text-white`}>Olvidé mi contraseña</Text>
      </TouchableOpacity>
    </View>
  );
}